/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfTenantSmtpDto,
  DataEnvelopeOfTenantSmtpTestResultDto,
  ErrorEnvelope,
  UpdateTenantSmtpDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getTenantSmtp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantSmtpDto>(
    { url: `/v1/tenants/smtp`, method: 'GET', signal },
    options,
  )
}

export const getGetTenantSmtpQueryKey = () => {
  return [`/v1/tenants/smtp`] as const
}

export const getGetTenantSmtpQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantSmtp>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSmtp>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTenantSmtpQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantSmtp>>> = ({ signal }) =>
    getTenantSmtp(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantSmtp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantSmtpQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantSmtp>>>
export type GetTenantSmtpQueryError = unknown

export function useGetTenantSmtp<
  TData = Awaited<ReturnType<typeof getTenantSmtp>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSmtp>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSmtp>>,
          TError,
          Awaited<ReturnType<typeof getTenantSmtp>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSmtp<
  TData = Awaited<ReturnType<typeof getTenantSmtp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSmtp>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSmtp>>,
          TError,
          Awaited<ReturnType<typeof getTenantSmtp>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantSmtp<
  TData = Awaited<ReturnType<typeof getTenantSmtp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSmtp>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTenantSmtp<
  TData = Awaited<ReturnType<typeof getTenantSmtp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantSmtp>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTenantSmtpQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const updateTenantSmtp = (
  updateTenantSmtpDto: UpdateTenantSmtpDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantSmtpDto>(
    {
      url: `/v1/tenants/smtp`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateTenantSmtpDto,
      signal,
    },
    options,
  )
}

export const getUpdateTenantSmtpMutationKey = () => ['updateTenantSmtp'] as const

export const getUpdateTenantSmtpMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTenantSmtp>>,
    TError,
    UpdateTenantSmtpMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTenantSmtp>>,
  TError,
  UpdateTenantSmtpMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateTenantSmtpMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTenantSmtp>>,
    UpdateTenantSmtpMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return updateTenantSmtp(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateTenantSmtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTenantSmtp>>
>
export type UpdateTenantSmtpMutationBody = UpdateTenantSmtpDto
export type UpdateTenantSmtpMutationError = ErrorEnvelope
export type UpdateTenantSmtpMutationVariables = { data: UpdateTenantSmtpDto }

export const useUpdateTenantSmtp = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTenantSmtp>>,
      TError,
      UpdateTenantSmtpMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTenantSmtp>>,
  TError,
  UpdateTenantSmtpMutationVariables,
  TContext
> => {
  return useMutation(getUpdateTenantSmtpMutationOptions(options), queryClient)
}
export const sendTenantSmtpTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfTenantSmtpTestResultDto>(
    { url: `/v1/tenants/smtp/test`, method: 'POST', signal },
    options,
  )
}

export const getSendTenantSmtpTestMutationKey = () => ['sendTenantSmtpTest'] as const

export const getSendTenantSmtpTestMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTenantSmtpTest>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<Awaited<ReturnType<typeof sendTenantSmtpTest>>, TError, void, TContext> => {
  const mutationKey = getSendTenantSmtpTestMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTenantSmtpTest>>, void> = () => {
    return sendTenantSmtpTest(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SendTenantSmtpTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTenantSmtpTest>>
>

export type SendTenantSmtpTestMutationError = ErrorEnvelope

export const useSendTenantSmtpTest = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendTenantSmtpTest>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof sendTenantSmtpTest>>, TError, void, TContext> => {
  return useMutation(getSendTenantSmtpTestMutationOptions(options), queryClient)
}
